
/**
@description Register custom handlers here  
@example 

ComponentManager.addHandler("foo", (data) => {
    console.log("foo", data);
});

*/ 

